import { cn } from "../../lib/utils";

const SidebarCard = ({ title, description, isActive, icon, children, actions, onClick }) => {
	return (
		// biome-ignore lint/a11y/useSemanticElements: the card contains independent action buttons and cannot be a button itself.
		<div
			onClick={onClick}
			onKeyDown={(event) => {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					onClick?.();
				}
			}}
			role="button"
			tabIndex={0}
			className={cn(
				'rounded-[2px] shadow-[0_1px_1px_theme("colors.dark.100")0d] bg-white p-5 cursor-pointer relative overflow-hidden group/sidebarCard',
				isActive &&
					"before:absolute before:left-0 before:top-0 before:h-full before:w-[6px] before:bg-primary-100"
			)}
		>
			<div className="flex items-center gap-2 justify-between">
				<div className="flex items-center gap-2 max-w-full overflow-hidden">
					{icon && (
						<div className="flex flex-none">
							<span className={cn("icon_16 default", icon)}></span>
						</div>
					)}
					<div className="text-dark-50 uppercase text-12 font-bold truncate">{title}</div>
				</div>

				{actions && (
					<div className="items-center gap-2 hidden flex-none group-hover/sidebarCard:flex">
						{actions}
					</div>
				)}
			</div>

			<div className="pt-2 pl-1">
				<div className="text-14 line-clamp-2">{description}</div>
			</div>

			{children}
		</div>
	);
};

SidebarCard.displayName = "SidebarCard";

export default SidebarCard;
